import React from 'react';
import { Box, TableCell, Typography } from '@mui/material';
import { Schedule, ChevronRight } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import StyledTableRow from '../../../../../app/components/StyledTableRow';

interface Props {
  restaurantId: string;
  menuId: string;
  onClick: () => void;
}

export const MenuAvailabilityRow: React.FC<Props> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <StyledTableRow onClick={onClick} sx={{ cursor: 'pointer' }}>
      <TableCell>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Schedule color="primary" />
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            {t('menu.details.manage-availability')}
          </Typography>
        </Box>
      </TableCell>
      <TableCell align="right">
        <ChevronRight sx={{ color: 'text.secondary' }} />
      </TableCell>
    </StyledTableRow>
  );
};
